var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      staticStyle: { "z-index": "100 !important", top: "-2px" },
      attrs: {
        active: true,
        parent: false,
        resizable: false,
        w: 705,
        h: 540,
        "drag-handle": ".drag-photo"
      }
    },
    [
      _c("loading-spinner", {
        attrs: { active: _vm.loading, "is-full-page": false, color: "accent" },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "card-container" }, [
            _c(
              "div",
              { staticClass: "flex-horizontal navbar-container drag-photo" },
              [
                _c("ArrowSVG", {
                  staticClass: "svg-style",
                  on: { click: _vm.closeDialog }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-horizontal action-buttons-container" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "photo-form-button",
                        attrs: { icon: "", small: "", color: "accent" }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: { size: "20" },
                            on: { click: _vm.rotateRight }
                          },
                          [_vm._v("rotate_right")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.photoInBase64,
                          download: _vm.imageData.varName + ".jpg"
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "photo-form-button",
                            attrs: { icon: "", small: "", color: "accent" }
                          },
                          [
                            _c("v-icon", { attrs: { size: "15" } }, [
                              _vm._v("vertical_align_bottom")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "photo-form-button",
                        attrs: { icon: "", small: "", color: "accent" },
                        on: { click: _vm.deletePhoto }
                      },
                      [
                        _c("v-icon", { attrs: { size: "15" } }, [
                          _vm._v("delete")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-vertical main-content-container scroll-fire-fox",
                style: "transform: rotate(" + _vm.rotation + "deg);"
              },
              [
                _c("img", {
                  staticClass: "photo-image",
                  attrs: { src: _vm.photoInBase64, alt: "photo" },
                  on: { click: _vm.openImageOnOtherTab }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { width: "100%" } }, [
              _c(
                "div",
                { staticClass: "photo-name" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.imageData.label) + "\n        "
                  ),
                  !_vm.disabled
                    ? _c("EditSVG", {
                        staticClass: "edit-description-icon",
                        class: { enabled: !_vm.editDisabled },
                        on: { click: _vm.toggleDescriptionEdition }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.photoDescription,
                    expression: "photoDescription"
                  }
                ],
                staticClass: "photo-description",
                class: { enabled: !_vm.editDisabled },
                attrs: {
                  placeholder: _vm.$t("NoPhotoDescription"),
                  disabled: _vm.editDisabled
                },
                domProps: { value: _vm.photoDescription },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.toggleDescriptionEdition.apply(null, arguments)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.photoDescription = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-750f89b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-750f89b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Photos/PhotoOpened.vue
// module id = null
// module chunks = 